import { Typography, Radio } from 'antd'
import classNames from 'classnames'

import Styled from './styled'

export default function RoleItem({ name, checked, onChange }) {
  return (
    <Styled
      className={classNames('role-item-component', { active: checked })}
      onClick={() => onChange(!checked)}
    >
      <div className="role-name">
        <Typography.Text>{name}</Typography.Text>
      </div>
      <div className="role-check">
        <Radio checked={checked} />
      </div>
    </Styled>
  )
}
